let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4V4fM")).then(() => parcelRequire('8DuT4'));